import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./responsive-overrides.css";
import { installAuthorizedFetch } from "./modules/microservices/mount";
import { customerAuthorizedFetch } from "./services/auth/customerSession";
import { getBackendBaseUrl } from "./services/backendMode";

installAuthorizedFetch(
  customerAuthorizedFetch,
  `${getBackendBaseUrl()}/api/v1/microservices`,
);

createRoot(document.getElementById("root")!).render(<App />);